import { FileDropZoneModal } from '@payaca/ambrosia';
import { getAcceptedFileTypes } from '@payaca/helpers/fileHelper';
import { requestPersistUploadAndLinkToEntity } from '@payaca/store/uploads/uploadsActions';
import { FC, useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';

const acceptFileTypes = getAcceptedFileTypes(['document', 'image', 'video']);

interface Props {
  scheduledEventId: number;
  isOpen: boolean;
  onClose: () => void;
  onUploadSuccess: () => void;
}

export const ScheduledEventFileUploadModal: FC<Props> = ({
  scheduledEventId,
  isOpen,
  onClose,
  onUploadSuccess,
}) => {
  const dispatch = useDispatch();

  const [showUploadError, setShowUploadError] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState(false);

  const onUploadFile = useCallback(
    async (files: File[]) => {
      setShowUploadError(false);
      setIsLoading(true);

      const uploadedFilePromises = await Promise.allSettled(
        files.map(
          (file) =>
            new Promise<void>((resolve, reject) => {
              dispatch(
                requestPersistUploadAndLinkToEntity(
                  {
                    file,
                    fileName: file.name,
                    entityId: scheduledEventId,
                    entityType: 'scheduledEvent',
                  },
                  (error) => {
                    if (error) {
                      reject();
                    } else {
                      resolve();
                    }
                  }
                )
              );
            })
        )
      );

      if (uploadedFilePromises.find((p) => p.status === 'rejected')) {
        setShowUploadError(true);
      }

      if (uploadedFilePromises.find((p) => p.status === 'fulfilled')) {
        onUploadSuccess();
      }

      setIsLoading(false);
    },
    // oxlint-disable-next-line eslint-plugin-react-hooks(exhaustive-deps) -- FIXME: pre-existing error: React Hook useCallback has missing dependencies: 'scheduledEventId', and 'dispatch'
    [onUploadSuccess]
  );

  return (
    <FileDropZoneModal
      isLoading={isLoading}
      hasError={showUploadError}
      isOpen={isOpen}
      onClose={onClose}
      dropzoneOptions={{
        // oxlint-disable-next-line typescript-eslint(no-misused-promises) -- FIXME: pre-existing error: Promise-returning function provided to property where a void return was expected.
        onDrop: onUploadFile,
        accept: acceptFileTypes.join(','),
      }}
    />
  );
};
